import { render, staticRenderFns } from "./table-registers.vue?vue&type=template&id=028f5d6a&"
import script from "./table-registers.vue?vue&type=script&lang=js&"
export * from "./table-registers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports